module.exports = __webpack_public_path__ + "static/media/DollyAgarwal.7b7a9ed7.png";